import { render, staticRenderFns } from "./RinvPL_List.vue?vue&type=template&id=18a929e4"
import script from "./RinvPL_List.vue?vue&type=script&lang=js"
export * from "./RinvPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports